import { render, staticRenderFns } from "./stepper-items.vue?vue&type=template&id=35d979ba"
import script from "./stepper-items.vue?vue&type=script&lang=js"
export * from "./stepper-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports